// extracted by mini-css-extract-plugin
export default {"active":"UserForm_active__vhKSh","new":"UserForm_new__hnjbc","toolTip":"UserForm_toolTip__MBkHA"};